import SearchResultHorizontal from "./SearchResultHorizontal";
import './SearchResultDropdown.css'
import { connectHits } from 'react-instantsearch-dom';
import ArrowRight from '../../common/images/arrowRight.svg';

const SearchResultDropdown = ({ hits, query, onSeeMoreResults }) => {
  if (!query || hits.length === 0) return (<></>)

  return (
    <div className="search-result-dropdown-anchor">
      <div className="search-result-dropdown-wrapper">
        <div className="search-result-dropdown">
          <div className="search-results">
            {hits.map(hit => (
              <SearchResultHorizontal hit={hit} key={hit.id} />
            ))}
          </div>
          <div className="see-more-results" onClick={onSeeMoreResults}>
            <span>Ver mais resultados</span>
            <img
              src={ArrowRight}
              alt="Arrow Right"
              width="18px"
              height="18px"
            />
          </div>
        </div>
      </div>
    </div>
  )
};

export default connectHits(SearchResultDropdown);
